/** The activation header and card share one width, so their edges line up. */
export const ACTIVATION_CONTENT_WIDTH = 'max-w-3xl';
